import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './css/NewPred.css';
import './css/SelectModels.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX } from '@fortawesome/free-solid-svg-icons';
import labService from './labService';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import token_red from './images/token-red.png'
import token_green from './images/token-green.png'
import HashLoader from "react-spinners/HashLoader";


const SelectModels = ({ isCollapsed, toggleSidebar }) => {
    const navigate = useNavigate();
    const { pk } = useParams();
    const [modelsList, setModelsList] = useState([]);
    const [selectedModels, setSelectedModels] = useState([]);
    const [error, setError] = useState(null);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [selectedModelDetails, setSelectedModelDetails] = useState(null);
    const [selectedModelId, setSelectedModelId] = useState(null);
    const [imageData, setImageData] = useState(null);
    const [analysis, setAnalysis] = useState(null);
    const [loadPage, setloadPage] = useState(true);

    useEffect(() => {
        const fetchAnalysis = async () => {
            const token = JSON.parse(localStorage.getItem('user'))?.access;
            try {
                const response = await labService.getAnalysisDetail(pk, token);
                const data = response.data;


                if (data.anal_status === "Done") {
                    navigate('/laboratory'); // Redirect if status is "Done"
                } else {
                    setAnalysis(data); // Set analysis data if status is not "Done"
                }
            } catch (error) {
                console.error("Error fetching analysis:", error);
                // Handle the error (e.g., show a message, redirect, etc.)
            }
        };

        fetchAnalysis();
    }, [pk]);


    useEffect(() => {
        const token = JSON.parse(localStorage.getItem('user'))?.access;
        
        if (!token) {
            setError("You must be logged in to view this page.");
            return;
        }

        const fetchSelectModels = async () => {
            try {
                const response = await labService.getSelectModels(pk, token);
                setModelsList(response.data.ml_models);
                const firstModelId = response.data.ml_models[0].id;
                setSelectedModelId(firstModelId)
                const modelDetailsResponse = await labService.getModelDetails(firstModelId, token);
                setSelectedModelDetails(modelDetailsResponse.data.model_details);
                console.log(modelDetailsResponse.data.model_details.descriptors_desc)

            } catch (error) {
                console.error('Error fetching prediction details:', error);
                setError('Failed to fetch models. Please try again.');
            }
        };

        const fetchImageSmiles = async () => {
            try {
                const response = await labService.getSmilesImage(pk, token);
                setImageData(response.data.image_data);
            } catch (error) {
                console.error('Error fetching prediction details:', error);
                setError('Failed to fetch models. Please try again.');
            } finally {
                setloadPage(false);
            }
        };

        fetchImageSmiles();
        fetchSelectModels();
    }, [pk]);

    useEffect(() => {
        const fetchUserData = async () => {
            const userData = localStorage.getItem('user');
            if (!userData) {
                setLoading(false);
                return;
            }

            const parsedUserData = JSON.parse(userData);
            const token = parsedUserData.access;
            if (!token) {
                setLoading(false);
                return;
            }

            try {
                const response = await labService.getUserInfo(token);
                setUser(response.data);
            } catch (error) {
                console.error('Error fetching user data', error);
            } finally {
                setLoading(false);
            }
            
        };

        fetchUserData();
    }, []);


    const handleCheckboxChange = (modelId) => {
        setSelectedModels((prevSelectedModels) => {
            if (prevSelectedModels.includes(modelId)) {
                // Remove the model if it's already selected
                return prevSelectedModels.filter((id) => id !== modelId);
            } else {
                // Add the model if it's not already selected
                return [...prevSelectedModels, modelId];
            }
            
        });
    };

    const closeSelectModels = () => {
        navigate('/laboratory');
    };

    const handleRunPredictions = async () => {
        // Retrieve user data from localStorage
        const userData = localStorage.getItem('user');
        if (!userData) {
            setError("You must be logged in to run predictions.");
            return;
        }
    
        const parsedUserData = JSON.parse(userData);
        const token = parsedUserData.access;
        if (!token) {
            setError("Invalid authentication token.");
            return;
        }
    
        // Prepare the data payload
        const data = { ml_models: selectedModels };
    
        try {
            // Make the POST request to run predictions
            const response = await labService.runCalcPrediction(pk, data, token);
            
            // Check if the response contains a redirect URL
            if (response.status === 201 && response.data.redirect_url) {
                navigate(response.data.redirect_url);
            }
        } catch (error) {
            console.error('Error running predictions:', error);
            // Optionally, you can set an error message to display to the user
            setError('Failed to run predictions. Please try again.');
        }
    };

    const handleModelClick = async (modelId) => {
        setSelectedModelId(modelId);
        const selectedModel = modelsList.find(model => model.id === modelId);
    
        if (selectedModel) {
            try {
                // If the details are in `selectedModel`, use them, otherwise fetch them
                if (selectedModel.model_details) {
                    setSelectedModelDetails(selectedModel.model_details);
                } else {
                    const token = JSON.parse(localStorage.getItem('user'))?.access;
                    const response = await labService.getModelDetails(modelId, token);
                    setSelectedModelDetails(response.data.model_details);
                }
            } catch (error) {
                console.error('Error fetching model details:', error);
            }
        }
    };    
    

    const totalCost = selectedModels.reduce((acc, selectedId) => {
        const model = modelsList.find(m => m.id === selectedId);
        return acc + (model ? model.model_price : 0);
      }, 0);
      


    return (
        <div className='lab-container'>
            <Navbar />
            <div className='lab-side-content'>
                <Sidebar active_n={2} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />
                <div className='new-pred-container'>
                    <div className='np-tabs'>
                        <div className='x'>
                            <button onClick={closeSelectModels} className='x-but'>
                                <FontAwesomeIcon className='icon-x' icon={faX} />
                            </button>
                        </div>
                        <div className='np-steps active-tab'>
                            <p className='p-step'>STEP 1</p>
                            <p>Select Model</p>
                        </div>
                        <div className='np-steps'>
                            <p className='p-step'>STEP 2</p>
                            <p>Define Compound</p>
                        </div>
                        <div className='np-steps'>
                            <p className='p-step'>STEP 3</p>
                            <p>Summary</p>
                        </div>
                        <div className='np-steps'>
                            <p className='p-step'>STEP 4</p>
                            <p>Results</p>
                        </div>
                
                    </div>

                    
                    <div className='sm-content'>
                        {loadPage ? (
                        <div className='loader-div'>
                            <HashLoader className='loader' size={120} color='#0b5578' />
                        </div>
                        ) : ( <>
                        <div className='np-conte'>
                            <div className="model-selection">
                                <ul className='model-list'>
                                    {modelsList.map((model) => (
                                    <li key={model.id} className='model-item'>
                                        <div className='models-container'>
                                            <input
                                                className='models-check'
                                                type="checkbox"
                                                checked={selectedModels.includes(model.id)}
                                                onChange={() => handleCheckboxChange(model.id)}
                                            />
                                            <label 
                                                className={`models-labels ${selectedModelId === model.id ? 'selected-label' : ''}`}
                                                onClick={() => handleModelClick(model.id)} style={{ cursor: 'pointer'}}
                                                >
                                                {model.name}
                                            </label>
                                        </div>
                                    </li>
                                    ))}
                                </ul>
                            </div>

                            <div className="model-details">
                                
                                {selectedModelDetails ? (
                                    <>
                                        <p className='main-text'>Model details</p>
                                        <p className='bigger-text'>Endpoint description</p>
                                        <p className='txt-greyish'>{selectedModelDetails.endpoint_desc}</p>

                                        <p className='bigger-text'>Type of model</p>
                                        <p className='txt-greyish'>{selectedModelDetails.type_of_model}</p>

                                        <p className='bigger-text'>Descriptors</p>
                                        {selectedModelDetails.descriptors_desc?.map((desc, idx) => (
                                            <p key={idx} className='txt-greyish'>
                                                {desc}
                                            </p>
                                        ))}




                                        <p className='bigger-text'>Statistics</p>
                                        <p className='txt-greyish'>{selectedModelDetails.statistics}</p>
                                    </>
                                ) : (
                                    <div className='see-model-det-div'>
                                        <svg className='see-model-det-svg' style={{ color:'rgb(128, 128, 128)'}} xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-exclamation-circle-fill" viewBox='0 0 16 16'>
                                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4m.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2"/>
                                        </svg>
                                        <p className='see-model-det grey-text'>Click on the model name to see it's details</p>
                                    </div>
                                )}
                            </div>

                            <div className="compound-info">
                                <div className='structer-image'>
                                    <p className='main-text yo-compound'>Your compound</p>
                                    <div className='smiles-img-div'>
                                        {imageData ? (
                                            <img className='smiles-img' src={`${imageData}`} alt="Analysis" />
                                        ) : (
                                            <img src="https://via.placeholder.com/300" alt="Compound structure" />
                                        )}
                                    </div>

                                    
                                    <p className='main-text yo-compound mrg-smil'>Compound SMILES notation:</p>
                                    <div className='smiles-notat-div'>
                                        {analysis ? (
                                        <p>{analysis.smiles}</p>
                                        ) : (
                                        <p>Loading...</p>
                                        )}
                                    </div>
                                    
                                </div>
                                <div className='cost-div'>
                                    <img
                                        className="token-cost"
                                        src={user && user.coins < totalCost ? token_red : token_green}
                                        alt="token icon"
                                    />
                                    <p className={`cost ${user && user.coins < totalCost ? 'not-enough-tokens' : ''}`}>{`Cost: ${totalCost} tokens`}</p>
                                </div>
                                {user && user.coins < totalCost && (
                                    <div>
                                        <p className="not-enough-tokens">You do not have enough tokens to make this amount of predictions.</p>
                                        <p className='grey-text'>Go to the <span className='boldy'>Wallet tab</span> to top up your account with tokens.</p>
                                        <p className='grey-text'>Don't worry, the current analysis will be <span className='boldy'>saved in your Lab.</span> After opening it, you will return to the stage where you left off.</p>
                                    </div>
                                )}
                                                                
                            </div>
                        </div>
                        <div className='btns'>
                            <button className="go-back-btn" onClick={closeSelectModels}>Go back</button>
                            <button onClick={handleRunPredictions} className={`${user && user.coins >= totalCost && totalCost>0 ? 'run-but-ready' : 'run-but'}`}>Run predictions</button>
                        </div>
                        </>)}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SelectModels;
